const entry = {
  secure: '기업 공간 확인 완료',
  title: '양식을 다시 쓰지 않고 기업의 사실에서 시작합니다.',
  body: '이 초대에 속한 기업 프로젝트를 확인했습니다. 지난 프로젝트를 계속하거나 새로운 시장 목표의 진단을 시작하세요.',
  identity: '현재 초대 ID',
  changeEmail: '다른 이메일로 로그인',
  signingOut: '로그아웃 중…',
  signOutFailed: '로그아웃할 수 없습니다. 연결을 확인한 뒤 다시 시도하세요.',
  existingTitle: '프로젝트로 돌아가기',
  existingBody: '마지막 프로젝트가 기본으로 선택됩니다',
  projectCount: '프로젝트 {count}개',
  ready: '준비됨',
  continueSetup: '설정 계속하기',
  targetMarkets: '목표 시장',
  lastOpened: '최근 접속',
  noMarkets: '설정되지 않음',
  viewProjects: '기존 프로젝트 보기',
  startDiagnosis: '새 진단 시작',
  serverTruth: '프로젝트 목록은 서버가 기준이며, 이 기기는 마지막 선택만 기억합니다.',
  emptyTitle: '첫 프로젝트 만들기',
  emptyHint: '이 초대에는 아직 기업 프로젝트가 없습니다',
  emptyLead: '4단계로 기업 설정 완료',
  emptyBody: '기업·제품 정보, 목표 시장, 공개 링크와 프로젝트 자료를 추가한 뒤 진단 범위를 확인합니다.',
  emptyNote: '자료 확인 전에는 저장하고 나갈 수 있습니다.',
}

export default entry
